import {
  defaultWorkspaceApiClient,
  type WorkspaceRequestCategory,
} from '@affine/core/modules/cloud';

export function requestWorkspaceSetting(
  workspaceId: string,
  path: string,
  init?: RequestInit,
  mode: 'background' | 'foreground' = requestModeFor(init),
  category: WorkspaceRequestCategory = 'settings',
  key = `${init?.method ?? 'GET'}:${path}`
): Promise<Response> {
  return defaultWorkspaceApiClient.request({
    workspaceId,
    path,
    init,
    category,
    key,
    mode,
    priority: mode === 'foreground' ? 'foreground' : 'visible',
  });
}

export async function requestWorkspaceSettingJson<T>(
  workspaceId: string,
  path: string,
  init?: RequestInit,
  mode?: 'background' | 'foreground'
): Promise<T> {
  const response = await requestWorkspaceSetting(workspaceId, path, init, mode);
  return (await response.json()) as T;
}

export function requestWorkspaceSettingGraphQL(
  workspaceId: string,
  query: string,
  variables?: Record<string, unknown>,
  mode: 'background' | 'foreground' = 'background',
  category: WorkspaceRequestCategory = 'settings',
  signal?: AbortSignal
): Promise<Response> {
  return requestWorkspaceSetting(
    workspaceId,
    '/graphql',
    {
      method: 'POST',
      headers: {
        'Apollo-Require-Preflight': 'true',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ query, variables }),
      signal,
    },
    mode,
    category,
    `graphql:${hashRequest(`${query}\n${JSON.stringify(variables ?? {})}`)}`
  );
}

function requestModeFor(init?: RequestInit): 'background' | 'foreground' {
  const method = init?.method?.toUpperCase() ?? 'GET';
  return method === 'GET' || method === 'HEAD' ? 'background' : 'foreground';
}

function hashRequest(value: string): string {
  let hash = 2166136261;
  for (let index = 0; index < value.length; index++) {
    hash ^= value.charCodeAt(index);
    hash = Math.imul(hash, 16777619);
  }
  return (hash >>> 0).toString(16);
}
